import {
  CloseOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  WarningOutlined,
} from '@ant-design/icons'
import { Button, Empty, Popconfirm, Select, Space, Tag, Tooltip, message } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect, useState } from 'react'
import { blue, yellowPrimary } from '../../color'
import { ASSIGNEE_TYPE } from '../../constants'
import { AvatarHasName } from '../Common/Avatar'
import { EmptyText } from '../Common/CellText'
import EmptyContent from '../EmptyContent'
import SpinnerInlineComponent from '../SpinnerInlineComponent/SpinnerInlineComponent'
import SelectGroupBox from './SelectGroupBox'
import { Modal } from 'antd'

const { Option } = Select

const SelectGroupPopup = props => {
  const {
    id,
    isVisibleSelectGroupPopup,
    handleSubmitSelectGroup,
    handleCancelSelectGroup,
    selectPeopleStore,
    groupType,
    onlySelectOne,
    noLoadSelectData,
    groupListOverride,
    companyListOverride,
    hideCompanySelector,
    centerCompanySelector,
    onLoadGroupMembers,
    onCompanyChange: onCompanyChangeCallback,
    authenticationStore,
    companyStore,
  } = props

  const {
    assigneePopupType,
    selectGroupData,
    setSelectGroupData,
    setGroupList,
    originGroupList,
    companyCode,
  } = selectPeopleStore
  const companyList =
    companyListOverride !== undefined
      ? companyListOverride
      : companyStore.companyList

  const [disableGroupList, setDisableGroupList] = useState([])

  const [isLoading, setIsLoading] = useState(false)
  const [prevSelectedGroupData, setPrevSelectedGroupData] = useState([])
  const [isCloseGroup, setIsCloseGroup] = useState(false)

  const handleRemoveSelect = useCallback(
    group => {
      setSelectGroupData({
        ...selectGroupData,
        [assigneePopupType]: selectGroupData[assigneePopupType].filter(
          el => el.id !== group.id
        ),
      })
    },
    [assigneePopupType, selectGroupData]
  )

  useEffect(() => {
    setPrevSelectedGroupData(selectGroupData[assigneePopupType])
  }, [isVisibleSelectGroupPopup])

  useEffect(() => {
    if (!assigneePopupType) return
    const selectedGroupList = [
      ...selectGroupData[ASSIGNEE_TYPE.LEADER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.COMBINER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ]
    setDisableGroupList(
      selectedGroupList
        .filter(el => el.permission !== assigneePopupType)
        .map(el => el.id)
    )
  }, [assigneePopupType])

  useEffect(() => {
    setGroupList(groupListOverride || originGroupList)
  }, [groupListOverride, isVisibleSelectGroupPopup])

  useEffect(() => {
    if (noLoadSelectData || !isVisibleSelectGroupPopup || !companyCode) return
      ; (async () => {
        if (authenticationStore.currentUser) {
          try {
            setIsLoading(true)
            setIsCloseGroup(true)
            await selectPeopleStore.getGroupList(groupType, companyCode)
          } catch (err) {
            console.log(err)
            message.error(err.vi || 'Đã có lỗi xảy ra!')
          } finally {
            setIsLoading(false)
            setIsCloseGroup(false)
          }
        }
      })()
  }, [
    authenticationStore.currentUser,
    companyCode,
    groupType,
    isVisibleSelectGroupPopup,
    noLoadSelectData,
  ])

  useEffect(() => {
    if (authenticationStore.currentUser) {
      selectPeopleStore.companyCode = authenticationStore.currentCompanyCode()
    }
  }, [authenticationStore.currentUser])

  const onCompanyChange = value => {
    selectPeopleStore.companyCode = value
    setGroupList([])
    if (!onCompanyChangeCallback) return

    setIsLoading(true)
    setIsCloseGroup(true)
    Promise.resolve(onCompanyChangeCallback(value))
      .then(groups => {
        if (Array.isArray(groups)) {
          setGroupList(groups)
        }
      })
      .catch(err => {
        console.error('Failed to load groups for selected company:', err)
        message.error(
          err.response?.data?.error ||
            err.message ||
            'Không thể tải danh sách nhóm IMSAT!'
        )
      })
      .finally(() => {
        setIsLoading(false)
        setIsCloseGroup(false)
      })
  }

  return (
    <Modal
      className="custom-modal-wrapper assign-member-modal"
      maskClosable={false}
      okText={'Đồng ý'}
      cancelText={'Hủy bỏ'}
      width={800}
      footer={null}
      style={{ top: 20 }}
      zIndex={props.zIndex || 1050}
      title={
        <div
          className={`assign-member-modal-title-container${
            centerCompanySelector ? ' company-selector-centered' : ''
          }`}>
          <div>
            {!hideCompanySelector && (
              <Select
                className={centerCompanySelector ? 'company-selector-vertical-centered' : ''}
                style={{ width: '100%', maxWidth: 400, borderRadius: 8 }}
                notFoundContent={<EmptyContent />}
                onChange={onCompanyChange}
                value={companyCode}
                placeholder={'-- Chọn công ty --'}>
                {companyList.map(item => (
                  <Option key={item.code} value={item.code}>
                    {item.name}
                  </Option>
                ))}
              </Select>
            )}
          </div>
          <div className="group-btn-action">
            <Popconfirm
              placement="bottom"
              zIndex={1600}
              title={'Bạn có chắc chắn muốn xóa hết người được chọn không ?'}
              onConfirm={() =>
              // clearSelectGroup
              //   ? clearSelectGroup()
              //   : handleCancelSelectGroup()

              {
                selectPeopleStore.handleRemoveSelectGroup()
              }
              }
              okText="Đồng ý"
              cancelText="Không">
              <Button
                danger
                style={{ borderRadius: 8 }}>
                Hủy chọn
              </Button>
            </Popconfirm>
            <Button
              type={'primary'}
              style={{ borderRadius: 8 }}
              onClick={() => {
                JSON.stringify(selectGroupData[assigneePopupType]) !==
                  JSON.stringify(prevSelectedGroupData)
                  ? handleSubmitSelectGroup()
                  : handleCancelSelectGroup()
              }}>
              Đồng ý
            </Button>
            <Tooltip title={'Đóng'}>
              <CloseOutlined style={{ fontSize: 20, cursor: 'pointer' }} onClick={handleSubmitSelectGroup} />
            </Tooltip>
          </div>
        </div>
      }
      closable={false}
      forceRender={true}
      visible={isVisibleSelectGroupPopup}>
      <div className="assign-member-modal-left-box">
        <div className="assign-member-modal-left-content" style={{ position: 'relative' }}>
          <SelectGroupBox
            disableGroupList={disableGroupList}
            onlySelectOne={onlySelectOne}
            isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
            isClose={isCloseGroup}
            groupListOverride={groupListOverride}
            onLoadGroupMembers={onLoadGroupMembers}
          />
          <SpinnerInlineComponent
            sizeSpin={'small'}
            isLoading={isLoading}
            noBackground
          />
        </div>
      </div>
      <div className="assign-member-modal-right-box">
        <div
          style={{
            marginBottom: 16,
            fontWeight: 500,
            color: '#333',
          }}>
          Danh sách đã chọn:
        </div>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 8,
          }}>
          {assigneePopupType &&
            selectGroupData[assigneePopupType]?.length > 0 &&
            selectGroupData[assigneePopupType].map(el => {
              return (
                <Tag
                  className={'tag-selected'}
                  color={'blue'}
                  key={el.id}
                  closable
                  onClose={() => handleRemoveSelect(el)}>
                  <AvatarHasName
                    imgId={el.image_id}
                    size={22}
                    name={el.full_name}
                    icon={
                      el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                        <TeamOutlined />
                      )
                    }
                  />
                </Tag>
              )
            })}
          {(!assigneePopupType ||
            !selectGroupData[assigneePopupType] ||
            selectGroupData[assigneePopupType]?.length === 0) && (
            <Empty
              style={{ width: '100%', marginTop: 50 }}
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Trống"
            />
          )}
        </div>
      </div>
    </Modal>
  )
}

SelectGroupPopup.propTypes = {}

export default inject(
  'selectPeopleStore',
  'loadingAnimationStore',
  'authenticationStore',
  'companyStore'
)(observer(SelectGroupPopup))
